export interface URLState {
  url: string;
  stateFromUrl: boolean;
}

export enum URLStoreMode {
  NEW,
  REPLACE
}

export interface URLParams {
  filters: string[];
  scroll: number;
  query: string;
  page?: number;
  [name: string]: any;
}
